module.exports = __webpack_public_path__ + "img/IL.51c6b6ad.png";